export const FILTER_TYPE = {
  MANUFACTURER: "manufacturers",
  PRICE: "prices",
  ENGINE: "engine",
  TIER0: "tier0",
  TIER1: "tier1",
  TIER2: "tier2",
  TIER3: "tier3",
  DESCRIPTION: "description",
  PHRASE: "phrase",
  VEHICLE: "vehicle",
  AVAILABILITY: "availabilities",
  FITMENT: "fitments",
  PAGE_TYPE: "pageType",
  SIZES: "sizes",
  DIAMETER: "diameters",
  WIDTH: "widths",
  OFFSET: "offsets",
  COLOR: "colors",
  TAGS: "productTags",
  MERCHANDISE_SIZES: "merchandiseSizes",
  CUSTOMTIRESIZE: "customTireSize",
  CUSTOMWHEELSIZE: "customWheelSize",
};
